module.exports = __webpack_public_path__ + "views/netcologne.77b4e358570ab0f937f621584a7ec41b.html";